import { Injectable, OnInit, Injector } from '@angular/core';
import {ParserService } from '../ws/ws.service';
import {environment} from '../../../../environments/environment';

import {IUserTypeManager} from './user-type-manager';
import {WsService2} from '../ws/ws.service';
@Injectable()
export class UserTypeParserService extends ParserService{
    constructor(ws: WsService2){
       super(ws);
    }
    setManager(r:IUserTypeManager){
        this.manager = r;
    }
   manager: IUserTypeManager
   parseMessage(m){
       switch (m.cmd){
           case "usertype": this.manager.onUserType(m.usertype); break;
       }
   }

}



// WEBPACK FOOTER //
// /app/src/app/wb/services/usertype/user-type-parser.service.ts